export const ISPM_MFE_CONFIG = {
  packageName: '@saviynt/ispm-ui',
  routePrefix: '/ECMv6/intelligence/ispm',
  containerId: 'ispm-mfe-content',
  errorContainerId: 'ispm-mfe-error',
};

export const ISPM_INTEGRATIONS_MFE_CONFIG = {
  packageName: '@saviynt/integrations',
  routePrefix: '/ECMv6/intelligence/integrations',
  containerId: 'integrations-mfe-content',
  errorContainerId: 'integrations-mfe-error',
};

export const AGENTS_MFE_CONFIG = {
  packageName: '@saviynt/agent',
  routePrefix: '/ECMv6/agent',
  containerId: 'agent-mfe-content',
  errorContainerId: 'agent-mfe-error',
};

export const AGENT_GATEWAYS_MFE_CONFIG = {
  packageName: '@saviynt/agent-gateway',
  routePrefix: '/ECMv6/agent-gateway',
  containerId: 'agent-gateway-mfe-content',
  errorContainerId: 'agent-gateway-mfe-error',
};

export const POLICIES_MFE_CONFIG = {
  packageName: '@saviynt/policies',
  routePrefix: '/ECMv6/intelligence/policies',
  containerId: 'policies-mfe-content',
  errorContainerId: 'policies-mfe-error',
};

export const NHI_OLCM_MFE_CONFIG = {
  packageName: '@saviynt/nhi-olcm',
  routePrefix: '/ECMv6/nhi-olcm',
  containerId: 'nhi-olcm-mfe-content',
  errorContainerId: 'nhi-olcm-mfe-error',
};
